/**
 * Get the current status of an episode based on the media endpoint structure
 * @param {Object} episode - The episode object from the media endpoint
 * @returns {Object} - Status information
 */
export const getEpisodeStatus = (episode) => {
  // Check if audio files exist and are not pending
  if (episode.audio_files && episode.audio_files.length > 0) {
    // Check if any audio file is still pending
    const hasPendingAudio = episode.audio_files.some(audio => audio.status === 'pending');
    
    if (hasPendingAudio) {
      return {
        status: 'audio_generating',
        message: 'Podcast is being recorded... Check back in a few minutes',
        hasAudio: false,
        hasScript: episode.script && episode.script.script_content
      };
    }
    
    // Audio files exist and are not pending, episode is complete
    return {
      status: 'complete',
      message: 'Episode ready to play',
      hasAudio: true,
      hasScript: episode.script && episode.script.script_content
    };
  }

  // Check script status
  if (episode.script) {
    // If script is pending, show script generation message
    if (episode.script.status === 'pending') {
      return {
        status: 'script_generating',
        message: 'Creating script... Check back in a few minutes',
        hasAudio: false,
        hasScript: false
      };
    }

    // If script is complete but no audio files yet, show audio generation message
    if (episode.script.status === 'completed' && (!episode.audio_files || episode.audio_files.length === 0)) {
      return {
        status: 'audio_generating',
        message: 'Podcast is being recorded... Check back in a few minutes',
        hasAudio: false,
        hasScript: true
      };
    }

    // If script failed
    if (episode.script.status === 'failed') {
      return {
        status: 'script_failed',
        message: 'Script generation failed',
        hasAudio: false,
        hasScript: false
      };
    }
  }

  // Default: episode exists but no script data yet
  return {
    status: 'pending',
    message: 'Episode created, waiting for processing... Check back in a few minutes',
    hasAudio: false,
    hasScript: false
  };
};
